import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { orderCancellationUrl } from '@app/helpers';
import { OrderCancellationStateService } from '../order-cancellation-state.service';

export const orderCancellationSuccessGuard = () => {
  if (inject(OrderCancellationStateService).canAccessSuccess) {
    return true;
  }
  return inject(Router).parseUrl(orderCancellationUrl);
};
